import { useTranslation } from 'react-i18next';

export const AuthorityQuote = () => {
  const { t } = useTranslation();
  return (
    <section
      data-testid="authority-quote-section"
      className="py-16 lg:py-24 px-6 sm:px-8"
      style={{ backgroundColor: 'var(--vc-bg)' }}
    >
      <div className="max-w-[800px] mx-auto text-center">
        <div
          className="relative px-8 py-8 rounded-[24px]"
          style={{
            backgroundColor: 'rgba(214,168,74,0.04)',
            border: '1px solid rgba(214,168,74,0.15)',
          }}
        >
          <blockquote>
            <p
              className="text-base sm:text-lg lg:text-xl leading-relaxed italic"
              style={{ fontFamily: 'Inter, sans-serif', color: 'var(--vc-fg)' }}
            >
              {t('authority.quote')}
            </p>
          </blockquote>
          <p
            className="mt-4 text-xs font-medium tracking-wider uppercase"
            style={{ color: 'var(--vc-gold)', fontFamily: 'Inter, sans-serif' }}
          >
            {t('authority.source')}
          </p>
        </div>
      </div>
    </section>
  );
};
